module.exports = __webpack_public_path__ + "static/media/Work-Sans-regular.f31fd395.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Work-Sans-regular/Work-Sans-regular.eot
// module id = 418
// module chunks = 0